import { makeStyles } from 'tss-react/mui';

export const useDataUsageCardStyles = makeStyles()({
  noDataContainer: {
    height: '24vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cardTitle: {
    fontWeight: '600',
    fontSize: '1.125rem',
    textTransform: 'uppercase',
    letterSpacing: '0.1em',
  },
  dataUsageCardContent: {
    padding: '1rem 1.5rem',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  chartWrapper: {
    position: 'relative',
    width: '50%',
    maxWidth: '180px',
  },
  legendWrapper: {
    width: 'max-content',
    maxWidth: '50%',
    paddingLeft: '2rem',
  },
  legendRow: {
    display: 'flex',
    flexDirection: 'row',

    '&:not(:last-child)': {
      marginBottom: '1rem',
    },
  },
  commonData: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
  greyText: {
    color: 'rgba(0, 0, 0, 0.5)',
  },

  square: {
    width: '1rem',
    height: '1rem',
    marginRight: '1rem',
    marginTop: '3px',
  },
});
